import React from "react";
import { Box, Button, Modal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import "./EventConfirmModal.css";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 520,
  maxWidth: "calc(100vw - 32px)",
  bgcolor: "background.paper",
  borderRadius: "12px",
  boxShadow: 24,
  p: "28px 34px 34px",
  outline: "none",
  textAlign: "center",
};

export const MarkPromotionCompletedModal = ({
  open,
  count = 1,
  onClose,
  onConfirm,
  confirming = false,
}) => {
  const many = count > 1;
  return (
    <Modal
      open={open}
      onClose={confirming ? undefined : onClose}
      aria-labelledby="mark-promotion-completed-title"
    >
      <Box sx={modalStyle} className="event-confirm-modal">
        <button
          type="button"
          className="event-confirm-modal__close"
          onClick={onClose}
          disabled={confirming}
          aria-label="Close"
        >
          <CloseIcon sx={{ fontSize: 18 }} />
        </button>

        <h2 id="mark-promotion-completed-title">
          Mark as Promotion Completed?
        </h2>
        <p className="event-confirm-modal__body">
          {many
            ? "Once these employees are marked Promotion Completed, it cannot be changed."
            : "Once this employee is marked Promotion Completed, it cannot be changed."}
        </p>

        <div className="event-confirm-modal__actions">
          <Button
            type="button"
            variant="outlined"
            className="event-confirm-modal__btn-secondary"
            onClick={onClose}
            disabled={confirming}
          >
            Go Back
          </Button>
          <Button
            type="button"
            variant="contained"
            className="event-confirm-modal__btn-primary"
            disableElevation
            onClick={onConfirm}
            disabled={confirming}
          >
            {confirming ? "Marking…" : "Mark as Completed"}
          </Button>
        </div>
      </Box>
    </Modal>
  );
};
